<template>
  <Tree
    :data="areaList"
    :load-data="loadData"
    @on-select-change="onSelectChange"
    @on-toggle-expand="onToggleExpand"
    expand-node
  ></Tree>
</template>

<script>
import api from "../../../../../api/request.js";
import Cookies from "js-cookie";

const URL = {
  GetCommunitylist: "api/User/GetCommunitylist", // 城市列表
  GetVillagelist: "api/User/GetVillagelist", // 区域列表
  GetSVillageList: "api/User/GetSVillageList", // 乡镇列表
  GetZVillageList: "api/User/GetZVillageList", // 村列表
  GetRoshRoomList: 'api/User/GetRoshRoomList', // 用户列表
};
export default {
  props: {
      type: {
        type: String,
        default: ''
      },
  },
  data() {
    return {
      areaList: [
        {
          title: "全部区域",
          expand: true,
          children: [],
          grade: 0
        }
      ]
    };
  },
  mounted() {
    // 加载城市列表
    this.GetRoshCommunityList();
  },
  methods: {
    // 保存刷新
    refreshChange(item) {
      this.GetRoshCommunityList();
    },

    // 加载城市列表
    GetRoshCommunityList(type = "") {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetCommunitylist}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          this.areaList[0].children = (res.Data || []).map(item => {
            return {
              title: item.Cname,
              loading: false,
              children: [],
              grade: 1,
              ...item
            };
          });
        }
      });
    },
    // 区域
    GetVillagelist(item, callback = null) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetVillagelist}?Ccode=${item.Ccode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          const data = (res.Data || []).map(item => {
            return {
              title: item.Vname,
              loading: false,
              children: [],
              grade: 2,
              ...item
            };
          });
          if (data.length) {
            callback(data);
          } else {
            callback([{
              title: '暂无数据',
              disabled: true
            }]);
          }
        }
      });
    },
    // 乡镇
    GetSVillageList(item, callback = null) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetSVillageList}?Vcode=${item.Vcode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          const data = (res.Data || []).map(item => {
            return {
              title: item.Sname,
              loading: false,
              children: [],
              grade: 3,
              ...item
            };
          });
          if (data.length) {
            callback(data);
          } else {
            callback([{
              title: '暂无数据',
              disabled: true
            }]);
          }
        }
      });
    },
    // 村
    GetZVillageList(item, callback = null) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetZVillageList}?Scode=${item.Scode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          const data = (res.Data || []).map(item => {
            let childrenItem = {
              title: item.Zname,
              grade: 4,
              ...item
            }
            if (this.type === 'device') {
              childrenItem.loading = false;
              childrenItem.children = []
            }
            return childrenItem;
          });

          if (data.length) {
            callback(data);
          } else {
            callback([{
              title: '暂无数据',
              disabled: true
            }]);
          }



        }
      });
    },
    // 用户列表
    GetRoshRoomList(item, callback = null) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: `${URL.GetRoshRoomList}`,
        data: {
          Zcode: item.Zcode,
          pageIndex: 1,
          pageSize: 1000
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          const data = (res.Data || []).map(lisk => {
            return {
              title: lisk.RoomName,
              Zcode: item.Zcode,
              grade: 5,
              ...lisk
            };
          });
          if (data.length) {
            callback(data);
          } else {
            callback([{
              title: '暂无数据',
              disabled: true
            }]);
          }
        }
      });
    },
    // 加载更多
    loadData(item, callback) {
      switch (item.grade) {
        case 1:
          this.GetVillagelist(item, callback);
          break;
        case 2:
          this.GetSVillageList(item, callback);
          break;
        case 3:
          this.GetZVillageList(item, callback);
          break;
        case 4:
          this.GetRoshRoomList(item, callback);
          break
        default:
          break;
      }
    },
    // 点击节点触发
    onSelectChange(list) {
      console.log(1);
        const [ item ] = list;
        if (item) {
            this.$emit('on-select-change', item)
        }
    },
    onToggleExpand(item) {
      console.log(2);
      this.$emit('on-select-change', item)
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/useGas/views/area/mods/tree.vue